import { useContext, useMemo } from 'react';
import { AppContext } from '../../core/context';
import useIsStocklistEnabled from '../../core/queries/useIsStocklistEnabled';
import type { ProductsViewMode } from '../types';
import { useTireSideFiltersEnabled } from '../components/TireSearchNew/ProductListTireSearch';

const useAvailableViewModes = () => {
    const isStocklistAvailable = useIsStocklistEnabled();
    const { enabled } = useTireSideFiltersEnabled();
    const { isInMobileView } = useContext(AppContext);
    return useMemo(() => {
        return [
            {
                mode: 'stockList',
                show: isStocklistAvailable && !isInMobileView,
            },
            {
                mode: 'table',
                show: enabled,
            },
            {
                mode: 'grid',
                show: true,
            },
            {
                mode: 'list',
                show: !isInMobileView,
            },
        ]
            .filter(item => item.show)
            .map(item => item.mode) as ProductsViewMode[];
    }, [isStocklistAvailable, isInMobileView, enabled]);
};

export default useAvailableViewModes;
